import { render } from "./schoolHome.vue?vue&type=template&id=2734ece0&scoped=true"
import script from "./schoolHome.vue?vue&type=script&lang=js"
export * from "./schoolHome.vue?vue&type=script&lang=js"

import "./schoolHome.vue?vue&type=style&index=0&id=2734ece0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2734ece0"]])

export default __exports__